import React from "react";
import Axios from "axios";

export default function AparatPlayer({
  overlay,
  baseUrl,
  video,
  styles,
  primary,
  secondary,
  ...props
}) {
  const frameRef = React.useRef();
  const target = `https://www.aparat.com/video/video/embed/videohash/${video}/vt/frame`;
  return (
    <iframe
      style={{
        height: props.height || "100%",
        width: props.width || "100%",
        borderRadius: props.borderRadius || "7px",
      }}
      src={target}
      ref={frameRef}
      allowFullScreen
      frameBorder={0}
      // styles={style}
      {...props}
    ></iframe>
  );
}
